{
  "slug": "iq-score-ranges-explained",
  "title": "আইকিউ স্কোরের পরিসীমা ব্যাখ্যা করা হয়েছে",
  "description": "সাধারণ আই. কে. স্কোর ব্যান্ড, প্রায়শই শতাংশ, বিশ্বাসের ব্যবধান এবং লেবেলের সীমানা অনুসন্ধান করুন।",
  "summary": "IQ স্কোর ব্যান্ডগুলি সুবিধাজনক সারসংক্ষেপ, কিন্তু সীমানা এবং লেবেল পরীক্ষার উপর নির্ভর করে ভিন্ন হতে পারে। স্কোরগুলি অনুমান হিসাবে এবং প্রসঙ্গে ব্যাখ্যা করা উচিত।",
  "sections": [
    {
      "heading": "সাধারণ পরিসীমাসমূহের জন্য একটি কার্যকর গাইড",
      "paragraphs": [
        "আর ওজন করো সঠিক পাল্লায়, -- 100 এবং এর মানদণ্ডিক বিভ্রান্তি 15এই ব্যান্ডগুলো সাধারণ দিক নির্দেশনা দেয়, এগুলো কোন রোগ নির্ণয়কারী শ্রেণী নয়।"
      ],
      "bullets": [
        "130 এবং উপরে: প্রায় উপরে 2%",
        "120–129: প্রায় 91স্ট-97% 1 সেকেন্ড",
        "110–119: প্রায় 75থে-90% 1 সেকেন্ড",
        "90–109: প্রশস্ত মধ্যবর্তী সীমা",
        "80–89: প্রায় 9থে-24% 1 সেকেন্ড",
        "70–79: প্রায় 2দ্বিতীয়8% 1 সেকেন্ড",
        "নিচে 70: প্রায় সর্বনিম্ন 2%"
      ]
    },
    {
      "heading": "লেবেলের মধ্যে পার্থক্য কেন",
      "paragraphs": [
        "প্রকাশক এবং প্রতিষ্ঠান বিভিন্ন শব্দ এবং কাট-অফ ব্যবহার করে। একটি সীমান্তে একটি ফলাফল একটি বিন্দু দূরে একটি থেকে অর্থবহভাবে ভিন্ন নয়, এবং বিশ্বাসযোগ্যতা অন্তরবর্তী প্রায়ই একাধিক ব্যান্ড অতিক্রম করে।",
        "উচ্চ বা নিম্ন ফলাফল শুধুমাত্র মোট থেকে ব্যাখ্যা করা উচিত নয়। একজন পেশাদার অনুকূল কার্যকারিতা, উন্নয়ন, শিক্ষা এবং ভাষার ক্ষেত্রে প্রযোজ্য।"
      ]
    },
    {
      "heading": "শুধুমাত্র সংখ্যা নয়, প্রোফাইল পড়ুন",
      "paragraphs": [
        "একই সার্বিক স্কোরের দুজন ব্যক্তির ভিন্ন ভিন্ন শক্তি থাকতে পারে । একজন হয়তো বাক্যগত যুক্তিবিজ্ঞানে পারদর্শী এবং অন্যজন হয়তো দৃশ্যমান নকশার ক্ষেত্রে পারদর্শী । একটি মিশ্রণ এই পার্থক্যগুলোকে লুকিয়ে রাখতে পারে ।",
        "অনলাইন স্কোরকে বিশেষ পরিস্থিতিতে স্ন্যাপশট হিসেবে ব্যবহার করুন, স্থায়ী লেবেল হিসেবে নয়।"
      ]
    }
  ],
  "faqs": [
    {
      "question": "কোনটাকে বলা হয় উচ্চ IQ?",
      "answer": "অনেক মাপকাঠিতে, 120 অথবা উপরে ভাল গড়ের উপরে এবং 130 অথবা উপরের দিকের উপরে 2%, কিন্তু শব্দভাণ্ডার ভিন্ন।"
    },
    {
      "question": "আইকিউ রেঞ্জের সীমানা কি সঠিক?",
      "answer": "না, মাপনের ভুল এবং বিভিন্ন শ্রেণীবিভাগের কারণে সীমানাগুলো আনুমানিক।"
    }
  ],
  "related": [
    "what-is-the-average-iq",
    "what-does-an-iq-of-120-mean",
    "what-does-an-iq-of-140-mean"
  ]
}
